const kv = () => {
  const kvvideo = document.querySelector('#js-kvvideo');

  if (kvvideo != null) {
    const messages = document.querySelectorAll('.p-top__kv__item');
    const toggleClass = () => {
      messages.forEach(message => {
        message.classList.remove('is-active');
      });
      messages[currentNum].classList.add('is-active');
    }

    let currentNum = 0;
    messages[0].classList.add('is-active');
  }
};
